import moment from 'moment';
import { CalendarSubmitSvg } from 'src/components/icons/Icon';
import { useResidentAvailabilitiesContext } from 'src/components/context/ResidentAvailibilitiesContext';

const timingsLabels: { [key: string]: string } = {
  morning: 'Morning (8am-12pm)',
  afternoon: 'Afternoon (12pm-4pm)',
  evening: 'Evening (4pm-8pm)',
  night: 'Night (8pm-11:59pm)',
};

const generateAvailabilityTimings = (timingsList: string[]) => {
  if (timingsList?.length >= 3) {
    return (
      <li>
        - Anytime (8am-
        {timingsList.includes('night') ? '11:59pm' : '8pm'}
        )
      </li>
    );
  }
  return timingsList?.map((timing) => (
    <li key={timing}>{`- ${timingsLabels?.[timing]}`}</li>
  ));
};
const AvailabilitySubmittedSuccess = () => {
  const {
    submittedAvailabilities,
  } = useResidentAvailabilitiesContext();

  return (
    <>
      <div className="availability-submission">
        <div className="icon">
          <CalendarSubmitSvg />
        </div>
        <h3 className="h4">Availability Submitted</h3>
        <p>We&apos;ll send you a text when your appointment is confirmed</p>
      </div>
      <div className="availability-selected" data-testId="selected-availability-container">
        <h3 className="h4 mb-8">You selected:</h3>
        {submittedAvailabilities?.resident_availability?.map((availability) => (
          <div
            className="availability-selected-box"
            data-testId="selected-availability-item"
            key={`submitted-date-${availability?.date}`}
          >
            <h5 className="h6">
              {moment(availability?.date, 'MM-DD-YYYY')?.format('dddd, MMMM DD')}
            </h5>
            <ul>{generateAvailabilityTimings(availability?.timings || [])}</ul>
          </div>
        ))}
      </div>
    </>
  );
};

export default AvailabilitySubmittedSuccess;
